/**
 * Class that creates upload widget with drag-and-drop and file list
 * @inherits qq.FileUploaderBasic
 */
define('commons/sigfox-uploader',['commons/file-uploader'], function(qq) {
    var SigfoxFileUploader = function(o){
        // call parent constructor
        qq.FileUploaderBasic.apply(this, arguments);
        
        // additional options    
        qq.extend(this._options, {
            element: null,
            multiple: false,
            // if set, will be used instead of qq-upload-list in template
            listElement: null,
            dragText: 'Drop files here to upload',
            uploadButtonText: 'Upload a file',
            candidateColumn: '',
            cancelButtonText: 'Cancel',
            failUploadText: 'Upload failed',
            template: '<div class="sigfox-uploader">' + 
                    '<div class="sigfox-upload-button toolbar-button icon" title="{uploadButtonText}"><span class="icon-upload-alt icon-2x"></span></div>' +
                    '<div class="sigfox-upload-radio-group">'+
                    '<p><input id="format_spots" type="radio" name="format" class="sigfox-upload-radio upload-format" checked="checked" value="spots"/><label for="format_spots">Coordinates</label><span class="icon-question-sign" title="Format : lat; lng; name (optional); description (optional); Antenna height AGL (optional, only for stations); antenna gain (optional, only for stations); environmental loss (optional, only for stations){candidateColumn}{typeColumn}"></span></p>'+
                    '<p><input id="format_addresses" type="radio" name="format" class="sigfox-upload-radio upload-format" value="addresses"/><label for="format_addresses">Addresses</label><span class="icon-question-sign" title="Format : address; name (optional); description (optional); Antenna height AGL (optional, only for stations); antenna gain (optional, only for stations); environmental loss (optional, only for stations){candidateColumn}{typeColumn}"></span></p>'+
                    '</div>' +
                    '<div class="sigfox-upload-radio-group" ' + (o.onlyStaticSpot ? 'style="display: none;"' : '') + '>'+
                    '<p><input id="type_coverage" type="radio" name="type" class="sigfox-upload-radio spot-type" checked="checked" value="coveragespot"/><label for="type_coverage">Stations</label></p>'+
                    '<p><input id="type_static" type="radio" name="type" class="sigfox-upload-radio spot-type" value="static"/><label for="type_static">Devices</label></p>'+
                    '</div>' +
                 '</div>',
            classes: {
                // used to get elements from templates
                button: 'sigfox-upload-button',
                result: 'sigfox-upload-result',
                radioGroup : 'sigfox-upload-radio-group',
                radio: 'sigfox-upload-radio',
                            
                // added to list item <li> when upload completes
                // used in css to hide progress spinner
                success: 'sigfox-upload-success',
                fail: 'sigfox-upload-fail'
            }
        });
        // overwrite options with user supplied    
        qq.extend(this._options, o);
        
        // overwrite the upload button text if any
        // same for the Cancel button and Fail message text
        this._options.template = this._options.template.replace(/\{uploadButtonText\}/g, this._options.uploadButtonText);
        this._options.template = this._options.template.replace(/\{candidateColumn\}/g, this._options.candidateColumn);
        this._options.template = this._options.template.replace(/\{typeColumn\}/g, this._options.typeColumn);
    
        this._element = this._options.element;
        this._element.innerHTML = this._options.template;
        
        this._classes = this._options.classes;
            
        this._button = this._createUploadButton(this._find(this._element, 'button'));
    };
    
    // inherit from Basic Uploader
    qq.extend(SigfoxFileUploader.prototype, qq.FileUploaderBasic.prototype);
    
    qq.extend(SigfoxFileUploader.prototype, {
        /**
         * Gets one of the elements listed in this._options.classes
         **/
        _find: function(parent, type){
            var element = qq.getByClass(parent, this._options.classes[type])[0];
            if (!element){
                throw new Error('element not found ' + type);
            }
            return element;
        },
        _onSubmit: function(id, fileName){
            var getParam = function(clazz, param) {
                var fields = qq.getByClass(this._options.element, clazz);
                if (fields[0].checked) {
                    this._options.params[param] = fields[0].value;
                } else if(fields[1].checked) {
                    this._options.params[param] = fields[1].value;
                }
            };
            getParam.call(this, "upload-format", "format");
            getParam.call(this, "spot-type", "type");
            qq.FileUploaderBasic.prototype._onSubmit.apply(this, arguments);
        }
    });

    return SigfoxFileUploader;
});
